/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import FloatingMenu from "../components/FloatingMenu";
import History from "@img/sejarah/sejarah.png";

const Sejarah = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [history, setHistory] = useState({
    background_image: [],
    title: "",
    description: "",
    image: "",
    short_title: "",
    short_description: "",
    founded: "",
    member: "",
    community: "",
    entrepreneur: "",
    logo: [],
  });

  useEffect(() => {
    if (history.background_image.length > 0) {
      const interval = setInterval(nextSlide, 3000);
      return () => clearInterval(interval);
    }
  }, [history.background_image]);

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + history.background_image.length) %
        history.background_image.length
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % history.background_image.length
    );
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await fetch("https://cms.okoce.net/api/admin/histories");
      if (!response.ok) {
        throw new Error("Gagal mengambil data nilai inti");
      }
      const data = await response.json();
      setHistory(
        data.data[0] || {
          background_image: [],
          title: "",
          description: "",
          image: "",
          short_title: "",
          short_description: "",
          founded: "",
          member: "",
          community: "",
          entrepreneur: "",
          logo: [],
        }
      );
    } catch (error) {
      setHistory({
        background_image: [],
        title: "",
        description: "",
        image: "",
        short_title: "",
        short_description: "",
        founded: "",
        member: "",
        community: "",
        entrepreneur: "",
        logo: [],
      });
    }
  };

  return (
    <>
      <div
        id="controls-carousel"
        className="relative w-full h-full top-[3rem] mb-[8rem]"
        data-carousel="slide"
      >
        <div className="relative overflow-hidden rounded-lg mobile:h-72 lg:min-h-screen">
          {history.background_image?.map((background_image, index) => (
            <div
              key={index}
              className={`duration-700 ease-in-out ${
                index === currentIndex ? "" : "hidden"
              }`}
              data-carousel-item={index === currentIndex ? "active" : ""}
            >
              <img
                src={`${process.env.REACT_APP_API_URL}/${background_image}`}
                className="absolute object-cover block h-full w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                alt={background_image}
              />
            </div>
          ))}
        </div>
        <button
          type="button"
          className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
          data-carousel-prev
          onClick={prevSlide}
        >
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none">
            <svg
              className="w-4 h-4 text-white rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 1 1 5l4 4"
              />
            </svg>
            <span className="sr-only">Previous</span>
          </span>
        </button>
        <button
          type="button"
          className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
          data-carousel-next
          onClick={nextSlide}
        >
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none">
            <svg
              className="w-4 h-4 text-whitertl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 9 4-4-4-4"
              />
            </svg>
            <span className="sr-only">Next</span>
          </span>
        </button>
      </div>
      <div className="mt-10 flex justify-center items-center">
        <img src={History} className="max-w-[80%] h-auto" alt="Sejarah" />
      </div>
      <section className="w-full mx-auto px-12 m-14">
        <div className="grid gap-5 p-4 m-2 mobile:grid-rows-1 mobile:p-0 mobile:m-0 lg:grid-cols-12">
          <main className="mobile:p-0 mobile:mr-1 mobile:ml-0 lg:p-10 lg:mr-14 lg:col-span-8">
            <h1 className="text-3xl font-bold text-center mb-8">
              {history.title}
            </h1>
            <div
              className="text-justify"
              dangerouslySetInnerHTML={{ __html: history.description }}
            />
          </main>

          <aside className="lg:col-span-4 lg:p-2">
            <img
              src={`${process.env.REACT_APP_API_URL}/${history.image}`}
              className="mobile:max-w-[14rem] mobile:mx-auto mobile:pl-4 mobile:mt-[3rem] lg:max-w-[20rem] lg:mx-auto lg:mt-[7rem]"
              alt="logo okoce"
            />
            <h1 className="text-3xl font-bold text-center mb-8 mt-10">
              {history.short_title}
            </h1>
            <div
              className="text-justify"
              dangerouslySetInnerHTML={{ __html: history.short_description }}
            />

            <div className="mt-10 grid justify-items-start mobile:grid-cols-2 mobile:gap-8 lg:grid-cols-2 lg:grid-flow-row lg:gap-6">
              <div className="max-w-16">
                <h1 className="font-extrabold text-4xl">{history.founded}</h1>
                <p className="mt-4">Founded</p>
              </div>
              <div className="max-w-32">
                <h1 className="font-extrabold text-4xl">{history.member}</h1>
                <p className="mt-4">Anggota Ok Oce </p>
              </div>
              <div className="max-w-16">
                <h1 className="font-extrabold text-4xl">{history.community}</h1>
                <p className="mt-4">Komunitas Penggerak</p>
              </div>
              <div className="max-w-16">
                <h1 className="font-extrabold text-4xl">
                  {history.entrepreneur}
                </h1>
                <p className="mt-4">wirausaha Baru</p>
              </div>
            </div>
          </aside>
        </div>
      </section>
      <div className="grid justify-items-center">
        <h1 className="text-4xl font-bold text-center mt-[4rem] mobile:text-3xl mobile:px-2 mb-6">
          Logo OK OCE Indonesia
        </h1>
        <div className="grid justify-items-center mobile:grid-cols-1 mobile:gap-0 lg:grid-cols-2 lg:grid-flow-col lg:gap-6 mb-4">
          {history.logo?.map((logo, index) => (
            <img
              src={`${process.env.REACT_APP_API_URL}/${logo}`}
              className="max-h-[12rem]"
              alt={`logo ${index}`}
            />
          ))}
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default Sejarah;
